import { IHttpService } from './IHttpService';
import { Auth } from '../../models/Auth';
import { Session } from '../../models/Session';
import { User } from '../../models/User';

const sessionRepoKey = (value: string) => `${value}-repo`;

export class FakeHttpService implements IHttpService {

    constructor() {
    }

    get = async <TResult>(url: string) => {
        console.log(`FakeHttpService - get - ${url}`);
        const promise: Promise<TResult | null> = new Promise(async (resolve, reject) => {
            try {
                const sessionKey = sessionRepoKey(url);
                const json = sessionStorage.getItem(sessionKey);
                const list = json ? JSON.parse(json) as TResult : null;
                resolve(list);
            } catch (error) {
                reject(error);
            } finally {
            }
        });
        return promise;
    }

    post = async <TData>(url: string, data: TData, multipartFormData: boolean = false) => {
        console.log(`FakeHttpService - post - ${url}: `, data);
        const promise: Promise<any> = new Promise(async (resolve, reject) => {
            try {
                if (url.includes('/auth')) {
                    const auth = data as Auth;
                    
                    if (auth.login === 'admin' && auth.password === 'admin') {
                        const session = new Session();
                        session.token = btoa(JSON.stringify(data));
                        session.user = new User();
                        session.user.name = auth.login;
                        resolve(session);
                        return;
                    }
                    reject('Invalid authentication data');
                    return;
                }

                const sessionKey = sessionRepoKey(url);
                const json = sessionStorage.getItem(sessionKey);
                const list = json ? JSON.parse(json) : [];
                const newList: any[] = [data, ...list];
                sessionStorage.setItem(sessionKey, JSON.stringify(newList));
                resolve(newList);
            } catch (error) {
                reject(error);
            } finally {
            }
        });
        return promise;
    }

    postToDownloadFile = <TData>(url: string, data: TData) => {
        console.log(`FakeHttpService - postToDownloadFile - ${url}: `, data);
        const promise: Promise<any> = new Promise(async (resolve, reject) => {
            try {
                resolve([]);
            } catch (error) {
                reject(error);
            } finally {
            }
        });
        return promise;
    }

    put = async <TData>(url: string, data: TData) => {
        console.log(`FakeHttpService - put - ${url}: `, data);
        const promise: Promise<any> = new Promise(async (resolve, reject) => {
            try {
                const sessionKey = sessionRepoKey(url);
                const json = sessionStorage.getItem(sessionKey);
                const list = json ? JSON.parse(json) : [];
                const newList: any[] = [data, ...list];
                sessionStorage.setItem(sessionKey, JSON.stringify(newList));
                resolve(newList);
            } catch (error) {
                reject(error);
            } finally {
            }
        });
        return promise;
    }

    delete = async <TResult>(url: string) => {
        console.log(`FakeHttpService - delete - ${url}`);
        const promise: Promise<TResult | null> = new Promise(async (resolve, reject) => {
            resolve(null);
        });
        return promise;
    }
}